import { useEffect, useState } from 'react';
import { SimulationFormFormState } from 'routes/HumanResourcesModule/Simulation/SimulationHome/components/SimulationModal/components/SimulationForm';

export function useSimulationFormState(
    initialState: SimulationFormFormState,
): [
    SimulationFormFormState,
    React.Dispatch<React.SetStateAction<SimulationFormFormState>>,
] {
    const [state, setState] = useState(initialState);
    const [isFormValid, setIsFormValid] = useState(false);

    useEffect(() => {
        if (
            state.selectedMonth &&
            state.title &&
            state.selectedType &&
            state.selectedOrgChartHrsSoftwareIds.length > 0
        )
            setIsFormValid(true);
    }, [
        state.selectedMonth,
        state.selectedType,
        state.title,
        state.selectedOrgChartHrsSoftwareIds,
    ]);

    return [{ ...state, isFormValid }, setState];
}
